import Parse from 'html-react-parser';

function BMP20241(props) {
    let svgCode =
    `<svg width="84" height="252" viewBox="0 0 84 252" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="168" width="84" height="84" fill="${props.darkFill}" fill-opacity="0.5"/>
        <path d="M42 196V224M56 210L28 210" stroke="${props.highlightColour}" stroke-width="4"/>
        <path d="M42 112V140M56 126L28 126" stroke="${props.highlightColour}" stroke-opacity="0.2" stroke-width="4"/>
        <path d="M42 28V56M56 42L28 42" stroke="${props.highlightColour}" stroke-opacity="0.2" stroke-width="4"/>
        <path d="M26 96L12 96L12 110" stroke="${props.highlightColour}" stroke-opacity="0.2" stroke-width="4"/>
        <path d="M25.9808 155.499L11.9808 155.499L11.9808 141.499" stroke="${props.highlightColour}" stroke-opacity="0.2" stroke-width="4"/>
        <path d="M58 155.499L72 155.499L72 141.499" stroke="${props.highlightColour}" stroke-opacity="0.2" stroke-width="4"/>
        <path d="M58 95.9808L72 95.9808L72 109.981" stroke="${props.highlightColour}" stroke-opacity="0.2" stroke-width="4"/>
    </svg>`

    props.svgReturn(57, svgCode, "bmp00241", 84, 252);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20241;